import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/pagination";

const CustomerItemsCarousel = ({
  breakpoint= {
    1440: {
      slidesPerView: 3.5,
    },
    1024: {
      slidesPerView: 2.5,
    },
    375: {
      slidesPerView: 1.5,
    },
  },
  swiperProps,
  data,
  drawerItems,
}) => {

  return (
    <>
      <Swiper
        modules={[Pagination, Autoplay]}
        spaceBetween={30}
        loop={true}
        slidesPerView={'auto'}
        autoplay={{
          delay: 2000,
        }}
        breakpoints={breakpoint}
        pagination={{ clickable: true }}
        className="!py-5 !overflow-visible"
        {...swiperProps}
      >
        {data?.map((item, index) => {
          return (
            <SwiperSlide className="text-white" style={{ height: 'auto' }} key={index}>
              {drawerItems?.render(index, item)}
            </SwiperSlide>
          )
        })}
      </Swiper>
    </>
  );
};

export default CustomerItemsCarousel;
